import Component from '../core/Component'
import {EMITS as FILTER_EMITS} from './Filter'

const STATES = {
    NORESULT: 'is-noresult'
}

export default class JobListing extends Component {
    constructor(element, options = {}) {
        super(element, options)

        this.ref = {
            filter: null,
            items: [],
            noResult: null
        }

        this.filter = null

        this.state = {
            items: [],
            filter: null,
            shouldUpdateItems: true
        }

        this.allItems = this.ref.items.map(element => ({
            element,

            location: element.dataset.location?.split(',') ?? [],
            sport: element.dataset.sport?.split(',') ?? [],
            role: element.dataset.role?.split(',') ?? [],
            type: element.dataset.type?.split(',') ?? [],
        }))
    }

    prepare() {
        if (this.ref.filter) {
            this.filter = Component.getFromElement(this.ref.filter)
            this.filter.on(FILTER_EMITS.CHANGE, this.handleFilterChange)

            const availableFilterValues = this.getAvailableFilterValues()
            this.filter.highlightAvailableFilters(availableFilterValues)
        }
    }

    handleFilterChange = ({filter}) => {
        this.applyFilter(filter)
        this.render()

        const availableFilterValues = this.getAvailableFilterValues()
        this.filter.highlightAvailableFilters(availableFilterValues)
    }

    render() {
        const items = this.getItems()

        this.allItems.forEach(item => item.element.classList.add('is-hidden'))
        items.forEach(item => item.element.classList.remove('is-hidden'))

        if (items.length === 0) {
            this.element.classList.add(STATES.NORESULT)
        } else {
            this.element.classList.remove(STATES.NORESULT)
        }
    }

    applyFilter(filter) {
        if (JSON.stringify(this.state.filter) === JSON.stringify(filter)) {
            return
        }

        this.state.filter = filter
        this.state.shouldUpdateItems = true
    }

    // vrati vsechny moznosti, ktery sou zrovna ve vypisu videt
    getAvailableFilterValues() {
        const items = this.getItems()

        const result = items.reduce((acc,item) => {
            for (const key in item) {
                if (key === 'element') {
                    continue
                }
                if (!acc[key]) {
                    acc[key] = {
                        values: []
                    }
                }
                acc[key].values = [...acc[key].values, ...item[key]]
            }
            return acc
        }, {})

        // pokud se hodnoty jeste nekombinujou mezi dropdowny, tak furt vypisovat vsechny moznosti pro ten dropdown, ve kterym zrovna vybiram
        const filter = this.state.filter || {}
        if (Object.keys(filter).length === 1) {
            for (const key in filter) {
                if (result[key] && result[key].values) {
                    result[key].values = this.allItems.reduce((acc, item) => {
                        acc = [...acc, ...item[key]]
                        return acc
                    }, [])
                }
            }
        }

        for (const key in result) {
            result[key].values = [...new Set(result[key].values)]
        }

        return result
    }

    //ziska vyfiltrovany itemy, pripadne to vytahne z cache
    getItems() {
        if (!this.state.shouldUpdateItems) {
            return this.state.items
        }

        const filter = this.state.filter || {}
        const filterPairs = Object.entries(filter)
        if (!filterPairs.length) {
            this.state.items = this.allItems
            return this.state.items
        }

        let result = []
        this.allItems.forEach(item => {
            let isFilteredOut = false

            for (let index = 0; index < filterPairs.length && !isFilteredOut; index++) {
                const [filterKey, filterData] = filterPairs[index]

                if (filterData.rule === 'array_contains') {
                    const intersection = filterData.values.filter(filterValue => item[filterKey].includes(filterValue))
                    isFilteredOut = intersection.length === 0
                }
                // else if (filterData.rule === 'CUSTOM_RULE') {
                //    isFilteredOut = true
                // }
            }

            if (!isFilteredOut) {
                result.push(item)
            }
        })

        this.state.items = result
        this.state.filter = filter
        this.state.shouldUpdateItems = false
        return result
    }

}